var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"vat","label":"Áfa","show-overflow-tooltip":"","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(_vm._f("currency")(scope.row.vat))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }